export default __webpack_public_path__ + "media/images/theme/wordmark_dark-c787dc1417f9f77d97c9ea833b91f69d.png";